// extracted by mini-css-extract-plugin
export default {"Title":"SimialItems_Title__Ybemy","TOP":"SimialItems_TOP__Wyi-i","Container":"SimialItems_Container__2p5wN"};